import { lazy, useEffect, useState, useSyncExternalStore } from 'react';
import MainLayout from 'layout/MainLayout';
// project import
import Loadable from 'components/Loadable';
import StockUpload from 'pages/stock_management/stockupload';
import SalesOrderUpload from 'pages/Sales Order/salesOrderUpload';
import { Navigate } from 'react-router-dom';
import { hasAuthenticatedUser, subscribeAuthState } from 'utils/authSession';
import { NODE_ENV, restoreSession } from 'Service/ApiService';
import { getDefaultAuthorizedRoute, hasAuthorizedMenuRoute } from 'utils/menuConfig';
import Barcodassessment from 'pages/Sales Order/Barcodsoassessment';
import OutStandingCPI from 'pages/Reports/OutStandingCPI';
import OutStanding from 'pages/Reports/OutStanding';
import LedgerPreviousYear from 'pages/Reports/LedgerPreviousYear';
import LedgerPreviousYearDetails from 'pages/Reports/LedgerPreviousYearDetails';
import LedgerPreviousDivWise from 'pages/Reports/LedgerPreviousDivWise';
import LedgerPreviousDivWiseDetails from 'pages/Reports/LedgerPreviousDivWiseDetails';
import VendorLedger from 'pages/Reports/VendorLedger';
import VendorLedgerDetails from 'pages/Reports/VendorLedgerDetails';
import Beats from 'pages/Beat/Beats';
import BeatCustomers from 'pages/Beat/BeatCustomers';
import BeatPlanning from 'pages/Beat/BeatPlanning';
import BeatCustomerReports from 'pages/Beat/BeatCustomerReports';
import DistributorReports from 'pages/Reports/DistributorReports';
import MarketIntelligence from 'pages/Beat/MarketIntelligence';
import DivisionOutStanding from 'pages/Reports/DivisionOutStanding';
// import BeatCustomerReports from 'pages/Beat/BeatCustomerReports';
// import BeatMReport from 'pages/Beat/BeatMReport';
import ProductCatalogue from 'pages/Product Catalogue/ProductCatalogue'
import UserReports from 'pages/Reports/UserReports';
import BarcodeScan from 'pages/SampleRequest/BarcodeScan';
import SampleRequestDashboard from 'pages/SampleRequest/SampleRequestDashboard';
import SampleSelection from 'pages/SampleRequest/SampleSelection';
import BarcodeDesign from 'pages/SampleRequest/BarcodeDesign';
import ViewSampleRequest from 'pages/SampleRequest/ViewSampleRequest';
import BarcodeDesign90days from 'pages/sampleRequest90days/BarcodeDesign90days';
import SampleRequest90daysDashboard from 'pages/sampleRequest90days/SampleRequest90daysDashboard';
import BarcodeScan90days from 'pages/sampleRequest90days/BarcodeScan90days';
import SampleSelection90days from 'pages/sampleRequest90days/SampleSelection90days';
import GoodAndReturns from 'pages/GoodAndReturns/GoodAndReturns';
import GoodAndReturnsTransfer from 'pages/GoodAndReturns/GoodAndReturnsTransfer';
import UserReports2 from 'pages/Reports/UserReports/index';
import PendingOrderReports from 'pages/Reports/PendingOrderReports';
import OutstandingReports from 'pages/Reports/OutstandingReports';
import CollectionReceived from 'pages/Reports/CollectionReceived';
import CombinedReportsUI from 'pages/Reports/CombinedReports';
import SchemeReport from 'pages/Reports/SchemeReport';
import GoodAndReturnsList from 'pages/GoodAndReturns/GoodAndReturnsList';
import ReportsDashboard from 'pages/Reports/ReportsDashboard';
import NotFound from 'pages/Auth/404';
import CollectionTargetAchvReport from 'pages/Reports/CollectionTargetAchvReport';
import CurrentMonthsSalesReport from "pages/Reports/CurrentMonthsSalesReport";
import NonBilledReports from 'pages/Reports/NonBilledReports';
import CheckBarcodeForStock from 'pages/stock_management/CheckBarcodeForStock';
import TourExpenseClaim from 'pages/TourExpenseClaim/TourExpenseClaim';
import DispayAndEvents from 'pages/DispayAndEvents/DispayAndEvents';
import SalesPerformance from 'pages/Sales Order/SalesPerformance';
import SalesPerformanceReport from 'pages/Reports/SalesPerformanceReport';
import AgencyPerformanceReport from 'pages/Reports/AgencyPerformanceReport';
import DealerOnePageReport from 'pages/Reports/DealerOnePageReport';
import AgencyOnePageReport from 'pages/Reports/AgencyOnePageReport';
import SalesPersonVisit from 'pages/SalesPersonVisit/SalesPersonVisit';
import DivisionOutStandingCPI from 'pages/Reports/DivisionOutStandingCPI';
import LedgerDivCPI from 'pages/Reports/LedgerDivCPI';

// Current Outstanding must use the CPI flow in both development and production.
const OutStandingPage =  NODE_ENV === 'production' ? OutStanding : OutStandingCPI;
const DivisionOutStandingPage = NODE_ENV === 'production' ? DivisionOutStanding : DivisionOutStandingCPI;

const Orders = Loadable(lazy(() => import('pages/Sales Order/Orders')));
const SampleCheck = Loadable(lazy(() => import('pages/sample_check/samplecheck')));
const SampleCheckFabric = Loadable(lazy(() => import('pages/sample_check/samplecheckfabric')));
const Barcodso = Loadable(lazy(() => import('pages/Sales Order/Barcodso')));
const Barcodsog = Loadable(lazy(() => import('pages/Sales Order/Barcodsog')));
const Stockselectionf = Loadable(lazy(() => import('pages/Sales Order/Stockselectionf')));
const SFAStockselectionf = Loadable(lazy(() => import('pages/Sales Order/FabricOrder/Stockselectionf')));
const Stockselectiong = Loadable(lazy(() => import('pages/Sales Order/Stockselectiong')));
const ProductBookingf = Loadable(lazy(() => import('pages/Sales Order/ProductBookingf')));
const FabricProductBookingf = Loadable(lazy(() => import('pages/Sales Order/FabricOrder/ProductBookingf')));
const ProductBookingg = Loadable(lazy(() => import('pages/Sales Order/ProductBookingg')));
const DeliverySchedulef = Loadable(lazy(() => import('pages/Sales Order/DeliverySchedulef')));
const SFADeliverySchedulef = Loadable(lazy(() => import('pages/Sales Order/FabricOrder/DeliverySchedulef')));
const FabricDeliveryConfirmation = Loadable(lazy(() => import('pages/Sales Order/FabricOrder/DeliveryConfirmationf')));
const DeliveryScheduleg = Loadable(lazy(() => import('pages/Sales Order/DeliveryScheduleg')));
const OrderDetails = Loadable(lazy(() => import('pages/Sales Order/OrderDetails')));
const OrderDetailsf = Loadable(lazy(() => import('pages/Sales Order/OrderDetailsf')));
const DeliveryConfirmation = Loadable(lazy(() => import('pages/Sales Order/DeliveryConfirmation')));
const Dashboad = Loadable(lazy(() => import('pages/Sales Order/Dashboad.js')));
const BarcodeDashboard = Loadable(lazy(() => import('pages/Sales Order/BarcodeDashboard')));
const AttedanceReport = Loadable(lazy(() => import('pages/Reports/AttedanceReport.js')));
const MyOrdersReport = Loadable(lazy(() => import('pages/Reports/MyOrdersReport.js')));
const LedgerReport = Loadable(lazy(() => import('utils/LedgerReport')));
const SeorReport = Loadable(lazy(() => import('utils/seoreport')));
const StockDownload = Loadable(lazy(() => import('pages/Downloads/StockDownload.js')));

const CustomerProfile = Loadable(lazy(() => import('pages/Customer Profile/CustomerProfile.js')));
const LedgerCurrentYearCPI = Loadable(lazy(() => import('pages/Reports/LedgerCurrentYearCPI.js')));
const LedgerCurrentYear = Loadable(lazy(() => import('pages/Reports/LedgerCurrentYear.js')));
// Current Year Ledger must use the CPI flow in both development and production.
const LedgerCurrentYearPage = NODE_ENV === 'production' ? LedgerCurrentYear : LedgerCurrentYearCPI ;
const LedgerDiv = Loadable(lazy(() => import('pages/Reports/LedgerDiv.js')));
const LedgerDivPage = NODE_ENV === 'production' ? LedgerDiv : LedgerDivCPI;
const LedgerCurrentYearDetails = Loadable(lazy(() => import('pages/Reports/LedgerCurrentYearDetails.js')));
const LedgerDivDetails = Loadable(lazy(() => import('pages/Reports/LedgerDivDetails.js')));
const PtFileController = Loadable(lazy(() => import('pages/Downloads/PtFile.js')));
const AssessmentReports = Loadable(lazy(() => import('pages/Reports/AssessmentReports.js')));
const DenknitSampleProcessList = Loadable(lazy(() => import('pages/DenknitSampleProcess/DenknitSampleProcessList')));
const DenknitSampleProcessForm = Loadable(lazy(() => import('pages/DenknitSampleProcess/DenknitSampleProcessForm')));
const DenknitSampleProcessBarcodeDashboard = Loadable(lazy(() => import('pages/DenknitSampleProcess/DenknitSampleProcessBarcodeDashboard')));
const DenknitSampleProcessBarcodeScan = Loadable(lazy(() => import('pages/DenknitSampleProcess/DenknitSampleProcessBarcodeScan')));
const DenknitSampleProcessStockSelection = Loadable(lazy(() => import('pages/DenknitSampleProcess/DenknitSampleProcessStockSelection')));
const DenknitSampleProcessFabricProductBooking = Loadable(lazy(() => import('pages/DenknitSampleProcess/DenknitSampleProcessFabricProductBooking')));
const DenknitSampleProcessGarmentProductBooking = Loadable(lazy(() => import('pages/DenknitSampleProcess/DenknitSampleProcessGarmentProductBooking')));
const DenknitSampleProcessFabricCheckout = Loadable(lazy(() => import('pages/DenknitSampleProcess/DenknitSampleProcessFabricCheckout')));
const DenknitSampleProcessGarmentCheckout = Loadable(lazy(() => import('pages/DenknitSampleProcess/DenknitSampleProcessGarmentCheckout')));
const DenknitNormalSalesOrderFabricBooking = Loadable(lazy(() => import('pages/DenknitNormalSalesOrder/DenknitNormalSalesOrderFabricBooking')));
const DenknitNormalSalesOrderGarmentBooking = Loadable(lazy(() => import('pages/DenknitNormalSalesOrder/DenknitNormalSalesOrderGarmentBooking')));
const SecondarySalesOrderList = Loadable(lazy(() => import('pages/SecondarySalesOrder/SecondarySalesOrderList')));
const SecondarySalesOrderForm = Loadable(lazy(() => import('pages/SecondarySalesOrder/SecondarySalesOrderForm')));
const SecondarySalesOrderBarcodeDashboard = Loadable(lazy(() => import('pages/SecondarySalesOrder/SecondarySalesOrderBarcodeDashboard')));
const SecondarySalesOrderBarcodeScan = Loadable(lazy(() => import('pages/SecondarySalesOrder/SecondarySalesOrderBarcodeScan')));
const SecondarySalesOrderProducts = Loadable(lazy(() => import('pages/SecondarySalesOrder/SecondarySalesOrderProducts')));
const DenknitSalesOrderSummaryReport = Loadable(lazy(() => import('pages/Reports/DenknitSalesOrderSummaryReport')));
const DenknitSampleProcessSummaryReport = Loadable(lazy(() => import('pages/Reports/DenknitSampleProcessSummaryReport')));
const DenknitSummaryReport = Loadable(lazy(() => import('pages/Reports/DenknitSummaryReport')));

//const ProductCatalogue = Loadable(lazy(() => import('pages/Product Catalogue/ProductCatalogue.js')));
// ==============================|| MAIN ROUTING ||============================== //
const useAuthSnapshot = () => useSyncExternalStore(subscribeAuthState, hasAuthenticatedUser, hasAuthenticatedUser);

const ProtectedMainLayout = () => {
  const isAuthenticated = useAuthSnapshot();
  const [isRestoring, setIsRestoring] = useState(!isAuthenticated);

  useEffect(() => {
    let isMounted = true;

    if (isAuthenticated) {
      setIsRestoring(false);
      return () => {
        isMounted = false;
      };
    }

    setIsRestoring(true);
    restoreSession().finally(() => {
      if (isMounted) {
        setIsRestoring(false);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [isAuthenticated]);

  if (isAuthenticated) {
    return <MainLayout />;
  }

  return isRestoring ? null : <Navigate to="/login" replace />;
};

const RootRedirect = () => {
  const isAuthenticated = useAuthSnapshot();
  return <Navigate to={isAuthenticated ? getDefaultAuthorizedRoute() : '/login'} replace />;
};

const AuthorizedMenuPage = ({ route, children }) => {
  if (!hasAuthorizedMenuRoute(route)) {
    return <Navigate to={getDefaultAuthorizedRoute()} replace />;
  }

  return children;
};

const MainRoutes = {
  path: '/',
  element: <ProtectedMainLayout />,
  children: [
    {
      path: '/',
      element: <RootRedirect />
    },
    {
      path: '/salesorder',
      element: <Orders />
    },
    {
      path: '/sales-performer',
      element: <SalesPerformance />
    },
    {
      path: '/sales-person-entry-for-visit',
      element: <SalesPersonVisit />
    },
    {
      path: '/sales-performer-report',
      element: <SalesPerformanceReport />
    },
    {
      path: '/agency-performance-report',
      element: <AuthorizedMenuPage route="/agency-performance-report"><AgencyPerformanceReport /></AuthorizedMenuPage>
    },
    {
      path: '/dealer-one-page-report',
      element: <AuthorizedMenuPage route="/dealer-one-page-report"><DealerOnePageReport /></AuthorizedMenuPage>
    },
    {
      path: '/agency-one-page-report',
      element: <AuthorizedMenuPage route="/agency-one-page-report"><AgencyOnePageReport /></AuthorizedMenuPage>
    },
    {
      path: '/dashboard',
      element: <Dashboad />
    },
    {
      path: '/barcodeSO',
      element: <Barcodso />
    },
    {
      path: '/barcodeSOg',
      element: <Barcodsog />
    },
    {
      path: '/stockselectionf',
      element: <Stockselectionf />
    },
    {
      path: '/sfa-stockselectionf',
      element: <SFAStockselectionf />
    },
    {
      path: '/stockselectiong',
      element: <Stockselectiong />
    },
    {
      path: '/productBookingf',
      element: <ProductBookingf />
    },
    {
      path: '/sfa-productBookingf',
      element: <FabricProductBookingf />
    },
    {
      path: '/productBookingg',
      element: <ProductBookingg />
    },
    {
      path: '/deliveryschedulef',
      element: <DeliverySchedulef />
    },
    {
      path: '/sfa-deliveryschedulef',
      element: <SFADeliverySchedulef />
    },
    {
      path: '/deliveryscheduleg',
      element: <DeliveryScheduleg />
    },
    {
      path: '/deliveryconfirmationf',
      element: <FabricDeliveryConfirmation />
    },
    {
      path: '/saleorderdetails',
      element: <OrderDetails />
    },
    {
      path: '/saleorderdetailsf',
      element: <OrderDetailsf />
    },
    {
      path: '/deliveryconfirmation',
      element: <DeliveryConfirmation />
    },
    {
      path: '/barcodedashboard',
      element: <BarcodeDashboard />
    },
    {
      path: '/barcodedashboard',
      element: <BarcodeDashboard />
    },
    {
      path: '/attedancereport',
      element: <AttedanceReport />
    },
    {
      path: '/myordersreport',
      element: <MyOrdersReport />
    },
    {
      path: '/customerProfile',
      element: <CustomerProfile />
    },
    {
      path: '/samplecheck',
      element: <SampleCheck />
    },
    {
      path: '/samplecheckf',
      element: <SampleCheckFabric />
    },
    {
      path: '/ledger',
      element: <LedgerReport />
    },
    {
      path: '/seoreport',
      element: <SeorReport />
    },
    {
      path: '/stockdownload',
      element: <StockDownload />
    },
    {
      path: '/stockupload',
      element: <StockUpload />
    },
    {
      path: '/check-barcode-for-stock',
      element: <CheckBarcodeForStock />
    },
    {
      path: '/salesOrderUpload',
      element: <SalesOrderUpload />
    },
    {
      path: '/ledgerCurrentYear',
      element: <LedgerCurrentYearPage />
    },
    {
      path: '/ledgerDiv',
      element: <LedgerDivPage />
    },
    {
      path: '/vendorLedger',
      element: <VendorLedger />
    },
    {
      path: '/vendorledgerDetails',
      element: <VendorLedgerDetails />
    },
    {
      path: '/ledgerCurrentYearDetails',
      element: <LedgerCurrentYearDetails />
    },
    {
      path: '/ledgerPreviousYearDetails',
      element: <LedgerPreviousYearDetails />
    },
    {
      path: '/previousDivWiseLedgerDetails',
      element: <LedgerPreviousDivWiseDetails />
    },
    {
      path: '/ledgerDivDetails',
      element: <LedgerDivDetails />
    },
    {
      path: '/ledgerPreviousYear',
      element: <LedgerPreviousYear />
    },
    {
      path: '/ledgerpreviousYear',
      element: <LedgerPreviousYear />
    },
    {
      path: '/previousDivWiseLedger',
      element: <LedgerPreviousDivWise />
    },
    {
      path: '/ptFile',
      element: <PtFileController />
    },
    {
      path: '/passessment',
      element: <Barcodassessment />
    },
    {
      path: '/divoutstanding',
      element: <OutStandingPage />
    },
    {
      path: '/divoutstandingnew',
      element: <DivisionOutStandingPage />
    },
    {
      path: '/assessment-reports',
      element: <AssessmentReports />
    },
    {
      path: '/beats',
      element: <Beats />
    },
    {
      path: '/beat-customers',
      element: <BeatCustomers />
    },
    {
      path: '/beat-planning',
      element: <BeatPlanning />
    },
    {
      path: '/beat-customer-reports',
      element: <BeatCustomerReports />
    },
    {
      path: '/distributorkpi-reports',
      element: <DistributorReports />
    },
    {
      path: '/market-intelligence',
      element: <MarketIntelligence />
    },
    // {
    //   path: '/beat-m-report',
    //   element: <BeatMReport />
    // },
    {
      path: '/product-catalogue',
      element: <ProductCatalogue />
    },
    {
      path: '/user-reports',
      element: <UserReports />
    },
    {
      path: '/sample-request-barcode-scan',
      element: <BarcodeScan />
    },
    {
      path: '/view-sample-request',
      element: <ViewSampleRequest />
    },
    {
      path: '/Denknit-sample_process',
      element: <DenknitSampleProcessList />
    },
    {
      path: '/secondary-sales-order',
      element: <SecondarySalesOrderList />
    },
    {
      path: '/secondary-sales-order/add',
      element: <SecondarySalesOrderForm />
    },
    {
      path: '/secondary-sales-order/barcode-dashboard',
      element: <SecondarySalesOrderBarcodeDashboard />
    },
    {
      path: '/secondary-sales-order/barcode-scan',
      element: <SecondarySalesOrderBarcodeDashboard />
    },
    {
      path: '/secondary-sales-order/barcode-entry',
      element: <SecondarySalesOrderBarcodeScan />
    },
    {
      path: '/secondary-sales-order/products',
      element: <SecondarySalesOrderProducts />
    },
    {
      path: '/Denknit-sample_process/add',
      element: <DenknitSampleProcessForm />
    },
    {
      path: '/Denknit-sample_process/barcode-dashboard',
      element: <DenknitSampleProcessBarcodeDashboard />
    },
    {
      path: '/Denknit-sample_process/barcode-scan',
      element: <DenknitSampleProcessBarcodeScan />
    },
    {
      path: '/Denknit-sample_process/fabric-selection',
      element: <DenknitSampleProcessStockSelection forcedOrderType="Fabric" />
    },
    {
      path: '/Denknit-sample_process/garment-selection',
      element: <DenknitSampleProcessStockSelection forcedOrderType="Garment" />
    },
    {
      path: '/Denknit-sample_process/fabric-product-booking',
      element: <DenknitSampleProcessFabricProductBooking />
    },
    {
      path: '/Denknit-sample_process/garment-product-booking',
      element: <DenknitSampleProcessGarmentProductBooking />
    },
    {
      path: '/Denknit-sample_process/fabric-checkout',
      element: <DenknitSampleProcessFabricCheckout />
    },
    {
      path: '/Denknit-sample_process/garment-checkout',
      element: <DenknitSampleProcessGarmentCheckout />
    },
    {
      path: '/denknit-normal-sales-order/fabric-booking',
      element: <DenknitNormalSalesOrderFabricBooking />
    },
    {
      path: '/denknit-normal-sales-order/garment-booking',
      element: <DenknitNormalSalesOrderGarmentBooking />
    },
    {
      path: '/sample-request-dashboard',
      element: <SampleRequestDashboard />
    },
    {
      path: '/sample-request-selection',
      element: <SampleSelection />
    },
    {
      path: '/sample-design',
      element: <BarcodeDesign />
    },
    {
      path: '/good-returns-list',
      element: <GoodAndReturnsList />
    },
    {
      path: '/good-returns',
      element: <GoodAndReturns />
    },
    {
      path: '/good-returns-transfer',
      element: <GoodAndReturnsTransfer />
    },
    {
      path: '/sample-design-sales-planning',
      element: <BarcodeDesign90days />
    },
    {
      path: '/dashboard-sales-planning',
      element: <SampleRequest90daysDashboard />
    },
    {
      path: '/barcode-scan-sales-planning',
      element: <BarcodeScan90days />
    },
    {
      path: '/sample-selection-sales-planning',
      element: <SampleSelection90days />
    },
    {
      path: '/user-reports-2',
      element: <UserReports2 />
    },
    {
      path: '/pending-order-reports',
      element: <PendingOrderReports />
    },
    {
      path: '/outstanding-reports',
      element: <OutstandingReports />
    },
    {
      path: '/collection-recieved',
      element: <CollectionReceived />
    },
    {
      path: '/CombinedReportsUI',
      element: <CombinedReportsUI />
    },
    {
      path: '/scheme-report',
      element: <SchemeReport />
    },
    {
      path: '/report-dashboard',
      element: <AuthorizedMenuPage route="/report-dashboard"><ReportsDashboard /></AuthorizedMenuPage>
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />
    },
    {
      path: '/404',
      element: <NotFound />
    },
    {
      path: '/collection-target-achv-report',
      element: <CollectionTargetAchvReport />
    },
    {
      path: '/current-month-sales-report',
      element: <CurrentMonthsSalesReport />
    },
    {
      path: '/non-billed-reports',
      element: <NonBilledReports />
    },
    {
      path: '/tour-expense-claim',
      element: <TourExpenseClaim />
    },
    {
      path: '/display-and-events',
      element: <DispayAndEvents />
    },
    {
      path: '/denknit-sales-order-summary-report',
      element: <DenknitSalesOrderSummaryReport />
    },
    {
      path: '/denknit-sample-process-summary-report',
      element: <DenknitSampleProcessSummaryReport />
    },
    {
      path: '/denknit-summary-report',
      element: <DenknitSummaryReport />
    }
  ]
};

export default MainRoutes;
